import { Box } from '@mui/material'
import { WorkQueueStatus } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { useMemo } from 'react'

interface Props {
  status: WorkQueueStatus
}
export const WorkQueueStatusChip = ({ status }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const currentStatus: { label: string; color: ColorSchema } = useMemo(() => {
    switch (status) {
      case WorkQueueStatus.Stopped:
        return { label: t('stopped', 'Stopped'), color: 'warning' }
      case WorkQueueStatus.InProgress:
        return { label: t('inProgress', 'In progress'), color: 'busy' }
      case WorkQueueStatus.Finished:
        return { label: t('finished', 'Finished'), color: 'success' }
      case WorkQueueStatus.Todo:
        return { label: t('todo', 'To do'), color: 'info' }
      default:
      case WorkQueueStatus.Pending:
        return { label: t('pending', 'Pending'), color: 'info' }
    }
  }, [status, t])

  return (
    <Box data-cy='crane-split-work-queue-status-chip'>
      <ColoredLabel
        label={currentStatus.label}
        color={currentStatus.color}
        sx={{
          width: 'fit-content',
          backgroundColor: theme.palette[currentStatus.color].lighter,
        }}
      />
    </Box>
  )
}
